import { render, staticRenderFns } from "./WheelCharacteristics.vue?vue&type=template&id=c577830a&scoped=true&"
import script from "./WheelCharacteristics.vue?vue&type=script&lang=js&"
export * from "./WheelCharacteristics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c577830a",
  null
  
)

export default component.exports